import React, { memo } from "react";
// libraries and external components
import { TextField } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
// styles
import styles from "./textFieldMui.module.scss";
import "./textFieldMui.scss";
import { InputAdornment } from "@mui/material";
import LightTooltip from "../LightTooltip";

const TextFieldMui = ({
  id = null,
  type = "text",
  label,
  onChange,
  value,
  onKeyUp,
  readOnly = false,
  left,
  right,
  variant = "filled",
  multiline = false,
  error,
  helperText,
  tooltipTitleLeft,
  tooltipTitleRigth,
  rightInside = true,
  params,
  width = "100%",
  margin = "",
  InputProps = null,
  className,
  onKeyPress,
  placeholder = "",
  inputRef,
  paddingRight=null,
  onFocus,
  onBlur,
  onPaste,
}) => {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#157AD6",
      },
    },
  });

  const ClassNameContainer = `${styles.container} ${className}`;

  return (
    <ThemeProvider theme={theme}>
      <div
        className={ClassNameContainer}
        style={{
          "--width": width,
          "--margin": margin ?? "0 0 26px 0",
        }}
      >
        <FormControl
          className={styles.textFieldMUI}
          style={{
            fontSize: "8px",
            "--paddingRight": paddingRight
          }}
        >
          <TextField
            id={id}
            type={type}
            label={label}
            onPaste={onPaste}
            onChange={onChange}
            value={value}
            edge="end"
            variant={variant}
            onKeyUp={onKeyUp}
            onBlur={onBlur}
            onKeyPress={onKeyPress}
            onFocus={onFocus}
            multiline={multiline}
            placeholder={placeholder}
            ref={inputRef}
            {...params}
            InputProps={
              InputProps
                ? {
                    ...InputProps,
                    disableUnderline: true,
                  }
                : {
                    ...params?.InputProps,
                    startAdornment: tooltipTitleLeft ? (
                      <LightTooltip title={tooltipTitleLeft} placement="rigth">
                        <InputAdornment position="start">{left}</InputAdornment>
                      </LightTooltip>
                    ) : (
                      left
                    ),
                    endAdornment: tooltipTitleRigth ? (
                      <LightTooltip title={tooltipTitleRigth} placement="left">
                        <InputAdornment position="end">{right}</InputAdornment>
                      </LightTooltip>
                    ) : (
                      right
                    ),
                    disableUnderline: true,
                  }
            }
            disabled={readOnly}
            error={error}
            helperText={helperText}
          />
        </FormControl>
        {right &&
          !rightInside &&
          (tooltipTitleRigth ? (
            <LightTooltip title={tooltipTitleRigth} placement="left">
              <div>{right}</div>
            </LightTooltip>
          ) : (
            right
          ))}
      </div>
    </ThemeProvider>
  );
};

export default memo(TextFieldMui);
